import { useSelector, useDispatch } from 'react-redux'
import { userFollow } from '@app-core/profile/actions'
import { urlToLink } from '@libs/postTools'
import appUrlLib, { imageUrl } from '@libs/appUrl'
import { trackUserProfileInfoEnterFollowingList } from '@libs/eventTracking/profile/user-profile.info.enter-following-list'
import { trackUserProfileInfoEnterFanList } from '@libs/eventTracking/profile/user-profile.info.enter-fan-list'

const processUserInfoNumber = (num: number) => {
  if (num > 10000) {
    return `${(num / 10000).toFixed(1)}萬`
  }
  if (1000 <= num && num < 10000)
    return `${num.toString()[0] + ',' + num.toString().slice(1, num.toString().length)}`

  return num.toString()
}

const useUserInfo = () => {
  const dispatch = useDispatch()
  const profileUserInfo = useSelector<any, any>((state) => state.profile.getIn(['userInfo']))
  const userInfo = profileUserInfo.toJS().data
  const isMeRoute = useSelector<any, any>((state) => state.profile.getIn(['isMeRoute']))
  const isGuest = useSelector<any, any>((state) => state.profile.getIn(['isGuest']))
  const isSelf = useSelector<any, any>((state) => state.profile.getIn(['isSelf']))
  const currentUserImage = useSelector<any, any>((state) =>
    state.currentUser.getIn(['userInfo', 'img']),
  )

  const { mid, views, followers, following, des, photoUrl } = userInfo

  // me => 直接拿取 current user 照片，因目前 graph 會直接回傳 null
  // user => 有圖片顯示，沒圖片利用 mid 計算守護動物圖片
  const getPhotoUrl = () => {
    if (isMeRoute) return imageUrl(currentUserImage)

    if (photoUrl) return photoUrl

    const animalIndex = mid % 10
    const backgroundIndex = mid % 12

    return `/statics/images/avatar/animal_${animalIndex}_${backgroundIndex}.jpg`
  }

  const getHandleFollowButtonOnClick = (type) => () => {
    if (isGuest) {
      const confirmed = window.confirm('此操作需要登入才能使用喔！')
      if (confirmed) {
        const url = `${appUrlLib.appUrl}/login`
        if (window.RNApp && window.RNApp.webview) {
          window.RNApp.webview(url)
        } else {
          window.location.href = url
        }
      }
      return
    }
    dispatch(userFollow({ followID: mid, follow: type === 'follow' ? 1 : 0 }))
  }

  const handleOnFollowersNumberClick = (e) => {
    e.preventDefault()
    trackUserProfileInfoEnterFanList({
      toPage: {
        pageUrl: `${appUrlLib.appUrl}/user/${mid}/fans`,
        pageName: 'fan-list',
      },
    })

    const url = `${appUrlLib.appUrl}/user/${mid}/fans`
    if (window.RNApp && window.RNApp.webview) {
      window.RNApp.webview(url)
    } else {
      window.open(url)
    }
  }

  const handleOnFollowingNumberClick = (e) => {
    e.preventDefault()
    trackUserProfileInfoEnterFollowingList({
      toPage: {
        pageUrl: `${appUrlLib.appUrl}/user/${mid}/follow`,
        pageName: 'following-list',
      },
    })
    const url = `${appUrlLib.appUrl}/user/${mid}/follow`
    if (window.RNApp && window.RNApp.webview) {
      window.RNApp.webview(url)
    } else {
      window.open(url)
    }
  }

  const handleEditButtonOnClick = (e) => {
    e.preventDefault()
    if (isGuest) {
      const confirmed = window.confirm('此操作需要登入才能使用喔！')
      if (confirmed) {
        const url = `${appUrlLib.appUrl}/login`
        if (window.RNApp && window.RNApp.webview) {
          window.RNApp.webview(url)
        } else {
          window.location.href = url
        }
        return
      }
      return
    }

    const url = `${appUrlLib.appUrl}/user/editor`
    if (window.RNApp && window.RNApp.webview) {
      window.RNApp.webview(url)
    } else {
      window.location.href = url
    }
  }

  const profileData = [
    {
      name: '粉絲',
      number: processUserInfoNumber(followers),
      href: `${appUrlLib.appUrl}/user/${mid}/fans`,
      onClick: handleOnFollowersNumberClick,
    },
    {
      name: '瀏覽',
      number: processUserInfoNumber(views),
      href: ``,
      onClick: (e) => {
        e.preventDefault()
      },
    },
    {
      name: '追蹤中',
      number: processUserInfoNumber(following),
      href: `${appUrlLib.appUrl}/user/${mid}/follow`,
      onClick: handleOnFollowingNumberClick,
    },
  ]

  return {
    ...userInfo,
    isGuest,
    isMeRoute,
    isSelf,
    profileData,
    mid: userInfo.mid ?? window?.localStorage['user.token'],
    handleFollowButtonOnClick: getHandleFollowButtonOnClick('follow'),
    handleFollowingButtonOnClick: getHandleFollowButtonOnClick('following'),
    des: des && urlToLink(des.replace(/\r|\n/g, '<br />')),
    photoUrl: getPhotoUrl(),
    handleOnFollowersNumberClick,
    handleOnFollowingNumberClick,
    handleEditButtonOnClick,
  }
}

export default useUserInfo
